// extracted by mini-css-extract-plugin
export default {"idleAnimation":"Idle-module__idleAnimation--KYIqU","runningAnimation":"Idle-module__runningAnimation--iG1Xv","copilotRun":"Idle-module__copilotRun--jiyBF"};